<template>
    <router-view></router-view>
</template>
<script>
  /* ============
   * Entry Point
   * ============
   *
   * The entry point of the application
   */

  import store from './store';
  import { router, i18n } from './../bootstrap';
  import accountService from './services/account';

  export default {
    /**
     * The Vuex store
     */
    store,

    i18n,

    /**
     * The router
     */
    router,

    /**
     * Fires when the app has been mounted
     */
    mounted() {
      // If the user is authenticated,
      // fetch the data from the API
      if (this.$store.state.auth.authenticated) {
        accountService.find();
      }
    },
  };
</script>



// WEBPACK FOOTER //
// index.vue?b8e8d0da